// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1N8k5","footer":"ModalInfo_footer__rKbIX"};